import { useEffect } from 'react';
import { listenOccurrences } from '../../channels/tripOccurrencesChannel';
import { useTripOccurrencesStore } from '../../stores/useTripOccurrencesStore';

export function useTripOccurrencesChannel() {

    useEffect(() => {

        const unsubscribe = listenOccurrences(({ tipo, payload }) => {

            const {
                setOccurrencesBatch,
                upsertOccurrence,
                removeOccurrence
            } = useTripOccurrencesStore.getState();

            if (tipo === 'trip-occurrences') {

                setOccurrencesBatch(payload, false);

            }

            if (tipo === 'trip-occurrence-upsert') {

                upsertOccurrence(payload, false);

            }

            if (tipo === 'trip-occurrence-remove') {

                removeOccurrence(
                    payload.tripUid,
                    payload.occurrenceUid,
                    false
                );

            }

        });

        return unsubscribe;

    }, []);

}